const consolidatedMonthlyActivityResource = (() => {
	const _default_config = {
		width: {
			chart1: 0
		}
	};
	const init = (default_config, resource, resource_config) => {
		Object.assign(_default_config, default_config);
		Object.assign(_default_config, resource_config);
		_default_config.resource = resource;
		_default_config.last_selected_account_number_option = _default_config._default_option;
		_default_config.maped_data = new Map();
		_default_config.maped_data[_default_config._default_option] = _default_config.data[0];
		for (let i = 0; i < _default_config.account_level.length; ++i) _default_config.maped_data[templateEvents.stringMasking(_default_config.account_level[i].account_number)] = _default_config.account_level[i];
		appendHTML();
		templateEvents.updatedOnWindowResize(updateBarChart);
	};

    /**
     * appendHTML : appending html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
	const appendHTML = () => {
		appendTableHeaders();
		populateConsolidatedData();
		updateBarChart();
	};

	/**
     * bindColorCodes : binding color codes
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
	const bindColorCodes = (config, ar) => {
		config.color = { bars: {} };
		for (let i = 0; i < ar.length; ++i) config.color.bars["field" + (i + 1)] = ar[i];
	};

    /**
     * updateBarChart : updating chart
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
	const updateBarChart = () => {
		const config1 = getBarGraphData(_default_config.charts[_default_config.resource].chart1_keys);
		if (config1.is_visible_chart) loadChart(config1.data, "graphOne", config1.max);
		else templateUtil.addEmptySection("graphOne");

		const config2 = getBarGraphData(_default_config.charts[_default_config.resource].chart2_keys);
		if (config2.is_visible_chart) loadChart(config2.data, "graphTwo", config2.max, "graph2");
		else templateUtil.addEmptySection("graphTwo");

		updateLegends();
	};

    /**
     * getBarGraphData : returning graph data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
	const getBarGraphData = (chart_keys) => {
		let max_y_axis = 0, is_visible_chart = false;
		const data = [], keys = Object.keys(chart_keys), data_ar = _default_config.maped_data[_default_config.last_selected_account_number_option].summary;
		for (let i = Math.max(0, data_ar.length - 12); i < data_ar.length; ++i) {
			const obj = {};
			for (let j = 0; j < keys.length; ++j) {
				const val = data_ar[i][chart_keys[keys[j]]];
				obj[keys[j]] = val;
				if (isNaN(val)) continue;
				obj[keys[j]] = val;
				is_visible_chart = is_visible_chart || !!val;
				obj[keys[j] + "_is_neg"] = +obj[keys[j]] < 0;
				obj[keys[j]] = Math.abs(+obj[keys[j]]);
				max_y_axis = Math.max(max_y_axis, obj[keys[j]]);
			}
			data.push(obj);
		}
		return { data, max: max_y_axis, is_visible_chart };
	};

	/**
     * updateLegends : updating legends
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function updateLegends() {
		for (let tc = 0; tc < 2; ++tc) {
			let html_legends = "";
			for (let i = 0; i < _default_config["_" + _default_config.resource]["graph" + (tc + 1)].legends.length; ++i) {
				let html = initScript.bindAttrsOnHTMLTag("span", "", {
					"style": { "background": _default_config["_" + _default_config.resource]["graph" + (tc + 1)].color_codes[i] }
				}) + initScript.bindAttrsOnHTMLTag("label", _default_config["_" + _default_config.resource]["graph" + (tc + 1)].legends_value[i]);
				html_legends += initScript.bindAttrsOnHTMLTag("li", html );
			}
			initScript.innerHTMLToATarget("#monthlyActivityGraph" + (tc + 1), html_legends);
		}
	}

    /**
     * appendTableHeaders : appending html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	const appendTableHeaders = () => {
		let headers = _default_config.headers || Object.keys(_default_config.data[0].summary[0]), mid_panel_headers = initScript.removeUnexpectedElements(headers, ["month_year", "avg_daily_balance"]);
		_default_config.table_divs = _default_config.table_divs[_default_config.resource];
		_default_config.table_divs[1].columns = mid_panel_headers;
	};

    /**
     * loadChart : appending html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	const loadChart = (data, target_id, max_y_axis, type = "graph1") => {
		initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter(target_id, "#"), "");

		const lineData = []; var isLine = false;
		if(type == "graph1"){
			isLine = true;
			data.forEach(function(v){
				lineData.push({"model_name": v.model_name, "field3":(v.field3_is_neg)?-1*v.field3:v.field3}) 
				delete v.field3; delete v.field3_is_neg 
			});
		}
		const chart_config = _default_config.charts[_default_config.resource];
		const dd = initScript.getHTMLElementByDelimiter(_default_config.body.class + " .monthly-summery").height() + (initScript.getHTMLElementObject("header").length ? (30 + initScript.getHTMLElementObject("header").height()) : 0) + (initScript.getHTMLElementByDelimiter("mainnav").length ? initScript.getHTMLElementByDelimiter("mainnav").height() : 0);
		Object.assign(chart_config, {
			"max_y_axis": max_y_axis,
			"id": "#" + target_id,
			"width": _default_config.width.chart1 - 10,
			"data": data,
			"isLine": isLine,
			"lineData": lineData,
			"is_doller_format": true,
			"tooltip": {
				"top": dd - 60,
				"left": -42,
				"diff_class": "graph",
			}
		});
		bindColorCodes(chart_config, _default_config["_" + _default_config.resource][type].color_codes);
		charts.bar.init(chart_config);
	};

    /**
     * filterData : filtering data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	const filterData = () => {
		const _resource = _default_config.resource.replace("consolidated_", "").replace("account_level_", "");
		let filter_options = _default_config.filter || {};
		filter_options = Object.keys(filter_options);
		for (let i = 0; i < filter_options.length; ++i) {
			const html_config = [];
			let options = _default_config.account_number;
            if (options.length > 1) options = ["All"].concat(options);
			for (let j = 0; j < options.length; ++j) {
				html_config.push({
					"html":(options[j] === _default_config._default_option) ? (initScript.getObjectValue(_default_config, "body.config." + _default_config.resource + ".filter." + filter_options[i] + ".default_option") || options[j]) : options[j],
					"config": { "value": options[j] }
				});
			}
			initScript.getHTMLElementByDelimiter(initScript.keyToCamelCaseString(filter_options[i] + "_" + _resource + "_filter")).html(initScript.getCommonHTML(html_config, "option"));
		}
	};

    /**
     * populateConsolidatedData : showing consolidated html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function populateConsolidatedData() {
		_default_config["consolidated"] = _default_config.data;
		_default_config.account_number = templateEvents.maskingUtility(_default_config.data[0].account_number);
		var nonZeroRecords = _default_config.data[0].summary;
		if(_default_config.clientConfig && _default_config.clientConfig.hideBlankRows && true === _default_config.clientConfig.hideBlankRows){
			_default_config.data = nonZeroRecords.filter(e => e.avg_daily_balance !== 0)
		}
		else{
			_default_config.data = nonZeroRecords
		}
		templateUtil.appendTabelHeaders(_default_config);
		templateUtil.appendTabelRows(_default_config);
		filterData();
		updateLeftCard();
		_default_config.width.chart1 = initScript.getHTMLElementByDelimiter(_default_config.body.class + " .tab-content").width();
	}

    /**
     * refreshHTML : showing consolidated html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function refreshHTML() {
		var nonZeroRecords = _default_config.maped_data[_default_config.last_selected_account_number_option].summary;
		if(_default_config.clientConfig && _default_config.clientConfig.hideBlankRows && true === _default_config.clientConfig.hideBlankRows){
			_default_config.data = nonZeroRecords.filter(e => e.avg_daily_balance !== 0)
		}
		else{
			_default_config.data = nonZeroRecords
		}
		templateUtil.appendTabelRows(_default_config);
	}

    /**
     * getSelectedValue : returning selected value
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param event object
     */

	function getSelectedValue(event) {
		const selected_val = event.target.value.trim();
		if (_default_config.last_selected_account_number_option === selected_val) return;
		_default_config.last_selected_account_number_option = selected_val;
		updateLeftCard();
		refreshHTML();
		updateBarChart();
	}

    /**
     * updateLeftCard : 2 way binding
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

	function updateLeftCard() {
		initScript.compileJSONWithHTML(templates[_default_config.resource].left_card, "monthlySummaryLeftcard", _default_config.maped_data[_default_config.last_selected_account_number_option]);
		analyserV2.resolvePromise();
	}

	return {
		init,
		getSelectedValue
	};
})();
